export default "__VITE_ASSET__BgInm1J1__"